import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import { store } from "./store";

Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
// Vue.prototype.$apibase = "http://localhost:8000";
Vue.prototype.$apibase = "https://backend-471n.onrender.com";
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
